export async function fetchResourceByCommentId(commentId: number) {
  return http
    .get<{
      resource_id: number
      resource_type: ResourceType
      comment_area_id: number
      floor_id: number
      reply_id: number
    }>('/v1/comment/get_resource', {
      id: commentId
    })
    .then((res) => res.data)
}
